import { Surface } from '@vst/beam';

import DisconnectCart from '../DisconnectCart';

import styles from './index.module.scss';

const Content = () => {
  return (
    <Surface className={styles['cartDetails']}>
      <DisconnectCart />
    </Surface>
  );
};

export default Content;
